import {action} from 'mobx';
import {ValidationErrorDescription} from '@mintdata-wsp/common/controllers/network/generated/responses/ValidationErrorDescription';
import {
    FlowValidationError,
    MessageSeverity,
    MessageSource,
    SimulationId
} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {FlowSimulationMessagesController as BaseFlowSimulationMessagesController} from '@mintdata-wsp/common/controllers/flow/FlowSimulationMessagesController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';

export class FlowSimulationMessagesController extends BaseFlowSimulationMessagesController
{
    @action
    public logFlowErrors(simulationId:SimulationId, errors:FlowValidationError[]):void
    {
        const {flow, flowSimulation} = controllers.ui;
        const flowId = flowSimulation.getById(simulationId).functionId;

        flow.setFlowErrors(flowId, errors);

        for( const error of errors )
        {
            const message = controllers.ui.flowValidation.buildErrorMessage(error);

            this._logMessage(simulationId, message, MessageSeverity.Error, MessageSource.UI, error);
        }
    }

    @action
    public logCloudFlowErrors(simulationId:SimulationId, errors:ValidationErrorDescription[]):void
    {
        const {flow, flowSimulation} = controllers.ui;
        const flowId = flowSimulation.getById(simulationId).functionId;

        flow.setCloudFlowErrors(flowId, errors);

        for( const error of errors )
        {
            this._logMessage(simulationId, error.message, MessageSeverity.Error, MessageSource.Cloud, null, error);
        }
    }

    @action
    public clearAll(simulationId:SimulationId)
    {
        const {flow, flowSimulation} = controllers.ui;
        const flowId = flowSimulation.getById(simulationId).functionId;

        flow.clearFlowErrors(flowId);
        flow.clearCloudFlowErrors(flowId);

        flowSimulation.clearMessages(simulationId);
    }

}
